import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <div>
        <p className="haya">  This page was made by Haya Altamimi ✨</p>
      </div>
    </div>
  );
}
